import { httpHelper } from "@/helpers/http.helper";

/**
 * @function getBanners
 * Fetch all banners from the API.
 * @returns {Promise<Array>} BannerDto[]
 */
export async function getBanners() {
  try {
    const res = await httpHelper.get("/Banner");

    return Array.isArray(res?.data) ? res.data : [];
  } catch (error) {
    httpHelper.notifyApiError(error, "Error while loading banners");

    return [];
  }
}
